import { render, staticRenderFns } from "./CreatePurchaseOrder.vue?vue&type=template&id=a3635904&"
import script from "./CreatePurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./CreatePurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchaseOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports